/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import { useEffect } from 'react'
import { Outlet, Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../_metronic/helpers'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className='auth-page-bg d-flex flex-column flex-column-fluid h-100'>
      <Link to='/' className='mb-8'>
        <img alt='Logo' src={toAbsoluteUrl('/media/ablemate_logo.png')} className='h-75px' />
      </Link>
        <div className='auth-card-form'>
          <Outlet />
        </div>
    </div>
  )
}

export { AuthLayout }
